import { Component } from 'react';
import ReactModal from '../../../components/Modal';

class ConfirmationModal extends Component {
    constructor() {
        super();
    }
    render() {
        return (
            <ReactModal modalState={this.props.isOpen} className="width-md">
                <div className="manage-account-modal">
                    <div>Make Sure to Select Console Data</div>
                    <img className="my-16" src="/static/img/google-scope-permissions2.png" />
                    <div className="d-flex justify-content-end gap-8">
                        <button
                            onClick={this.props.onClose}
                            className="button button-outline button-primary width-sm btn"
                        >
                            Cancel
                        </button>
                        <a
                            href="/customers/link"
                            onClick={this.props.onClose}
                            className="button button-filled button-primary width-sm btn"
                        >
                            Okay
                        </a>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default ConfirmationModal;
